import React from 'react';
import ProduitsHeader from './FournisseurHeader';
import { Row } from 'react-bootstrap';
import ProduitsTable from './FournisseurTable';

const Produits = () => {
  return (
    <>
      <Row>
        <ProduitsHeader />
      </Row>
      <Row>
        <ProduitsTable />
      </Row>
    </>
  );
};

export default Produits;
